import { useState, useEffect } from "react";
import "./modal.scss";
import { FaPlusCircle } from "react-icons/fa";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select";
import Container from "components/LogIn/Container";
import DatePicker from "react-multi-date-picker";
import Loader from "../../../../utils/Loader";
import persian from "react-date-object/calendars/persian";
import { ToastContainer, toast } from "react-toastify";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import { connection } from "../../../../utils/apiConnection.ts";
import ReportModal from "./ReportModal.jsx";

function Modal({
  customers,
  Update,
  index,
  AllTags,
  modalUpdate,
  Coin,
  ChosenPeople,
  UpdateGroup,
  Coingroup,
  EditUser,
}) {
  const [status, setStatus] = useState("");
  const [status2, setStatus2] = useState(1);
  const [tags, setTags] = useState([]);
  const [tags2, setTags2] = useState([]);
  const [coin, setCoin] = useState("");
  const [coin2, setCoin2] = useState("");
  const [customer2, setsetCustomer2] = useState({});
  const [img, setimg] = useState("");
  const [invalid1, setInvalid1] = useState(false);
  const [invalid2, setInvalid2] = useState(false);
  const [invalid3, setInvalid3] = useState(false);
  const [labels, setLabels] = useState([
    { value: 200, label: "مدیریت اصلی(ادمین)" },
    { value: 201, label: "تعریف محصول(ادمین)" },
    { value: 202, label: "تعریف بسکت(ادمین)" },
    { value: 203, label: "مدیریت سفارش ها (ادمین)" },
    { value: 204, label: "دسترسی به سفارشات برای پیک (ادمین)" },
  ]);
  const [labels2, setLabels2] = useState([
    { value: 100, label: "مدیریت محصولات(سوپر ادمین)" },
    { value: 101, label: "(سوپر ادمین)مدیریت کاربران" },
    { value: 102, label: "مدیریت آپشن ها(سوپر ادمین)" },
    { value: 103, label: "مدیریت سفارشات(سوپر ادمین)" },
    { value: 104, label: "مدیریت فروشگاه(سوپر ادمین)" },
    { value: 200, label: "تنظیمات فروشگاه(ادمین)" },
    { value: 201, label: "تعریف محصول(ادمین)" },
    { value: 202, label: "تعریف بسکت(ادمین)" },
    { value: 203, label: "مدیریت سفارش ها (ادمین)" },
    { value: 204, label: "دسترسی به سفارشات برای پیک (ادمین)" },
    { value: 300, label: "بازاریاب" },
  ]);
  const [allLabels, setAllLabels] = useState([]);
  const [selectItems, setSelectItems] = useState([[{}, [{}]]]);

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [rolls, setRolls] = useState([]);
  const [allRolls, setAllRolls] = useState([]);

  const [suppliers, setSuppliers] = useState([]);
  const [supplier, setSupplier] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [smallLabels, setSmallLabels] = useState([]);

  const sendTags = (tags) => {
    //  connection("api/Insert_UserRoll", {
    //    supplier_id:,
    //    uid:,
    //    value:,
    //  }).then((res) => {});
  };

  useEffect(() => {
    setIsChecked(false);
    setSuppliers([]);
    setSupplier("");
    setSmallLabels([
      { value: "100-0", label: "مدیریت محصولات(سوپر ادمین)" },
      { value: "101-0", label: "(سوپر ادمین)مدیریت کاربران" },
      { value: "102-0", label: "مدیریت آپشن ها(سوپر ادمین)" },
      { value: "103-0", label: "مدیریت سفارشات(سوپر ادمین)" },
      { value: "104-0", label: "مدیریت فروشگاه(سوپر ادمین)" },
      { value: "300-0", label: "بازاریاب" },
    ]);
    setRolls([]);
    setAllRolls([]);
    customers[index] &&
      connection("api/Find_suppliers", {
        conditions: `main_status/=/0`,
      }).then((supplierData) => {
        supplierData.map((item) => {
          setSuppliers((prev) => [
            ...prev,
            { value: item.id, label: item.title },
          ]);
        });
        connection("api/Find_UserRoll", {
          conditions: `uid/=/${customers[index].users__id}`,
        }).then((res) => {
          if (res.length > 0) {
            setAllRolls(res);
            let rolls2 = [];
            res.map((item) => {
              let sup;
              if (item.supplier_id != 0) {
                sup = supplierData.filter(
                  (item2) => item2.id == item.supplier_id
                );
              } else {
                sup = [{ id: 0, title: "" }];
              }
              let rol = labels2.filter((item2) => item2.value == item.value);
              if (rol.length > 0 && sup.length > 0) {
                rolls2.push({
                  value: rol[0].value + "-" + sup[0].id,
                  label:
                    rol[0].label +
                    `${sup[0].id == 0 ? "" : "-"}` +
                    sup[0].title,
                });
              }
            });
            const unique = [
              ...new Map(rolls2.map((m) => [m.value, m])).values(),
            ];
            setRolls(unique);
          }
        });
        setIsChecked(true);
      });

    customers[index] && setStatus(customers[index].main_status == 1 ? 0 : 1);
    customers[index] && setsetCustomer2(customers[index]);
    setInvalid1(false);
    setInvalid2(false);
    setInvalid3(false);
    setCoin("");
    setStatus2(1);
    setTags2([]);
    setimg("");
    // console.log(document.querySelector("#editModal").classList);
  }, [customers[index], AllTags, modalUpdate]);
  return (
    <div className="modal-CM">
      <div
        className="modal fade"
        id={`editModal`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        {isChecked ? "" : <Loader />}
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کاربر
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close-edit-user"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data  ">
                  {customers[index] && (
                    <>
                      <div className="edit-user-item d-flex justify-content-between">
                        <label htmlFor="profile-pic">
                          <div className="profile-pic position-relative">
                            <input
                              className="d-none"
                              type="file"
                              accept="image/*"
                              id="ProfilePic"
                              onChange={(e) => {
                                setsetCustomer2({
                                  ...customer2,
                                  ["profile_pic_file_id"]: e.target.files[0],
                                });
                                setimg(URL.createObjectURL(e.target.files[0]));
                              }}
                            />
                            <img
                              src={
                                img == ""
                                  ? `${
                                      "http://sabadi.tatdemo.ir/" +
                                      customer2.path
                                    }`
                                  : `${img}`
                              }
                              alt=""
                              className="border border-dark"
                              style={{
                                width: "80px",
                                borderRadius: "50%",
                                height: "80px",
                                overflow: "hidden",
                              }}
                            />
                            <label
                              htmlFor="ProfilePic"
                              className="position-absolute text-dark"
                              style={{ right: "23px", top: "-10px" }}
                            >
                              <FaPlusCircle
                                className="hover-it"
                                style={{
                                  background: "white",
                                  borderRadius: "10px",
                                }}
                              />
                            </label>
                          </div>
                        </label>
                      </div>
                      <div className="edit-user-item d-flex justify-content-between">
                        <label
                          htmlFor="address-edit-user"
                          className="title w-25"
                        >
                          وضعیت{" "}
                        </label>
                        <div className="w-50">
                          <div class="form-check form-check-inline">
                            <label
                              class="form-check-label"
                              htmlFor="inlineRadio1"
                            >
                              فعال
                            </label>
                            <input
                              class="form-check-input"
                              type="radio"
                              id="inlineRadio1"
                              checked={status == 1 ? true : false}
                              onClick={(e) => {
                                setStatus(e.target.value == "on" ? 1 : 0);
                              }}
                              name="status"
                            />
                          </div>
                          <div class="form-check form-check-inline">
                            <label
                              class="form-check-label"
                              htmlFor="inlineRadio2"
                            >
                              غیر فعال
                            </label>
                            <input
                              class="form-check-input"
                              type="radio"
                              id="inlineRadio2"
                              checked={status == 0 ? true : false}
                              onClick={(e) => {
                                setStatus(e.target.value == "on" ? 0 : 1);
                              }}
                              name="status"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="edit-user-item d-flex justify-content-between">
                        <label
                          className="title mt-1"
                          htmlFor="name-edit-user"
                          style={{ width: "30%" }}
                        >
                          نام و نام خانوادگی :
                        </label>
                        <input
                          type="text"
                          className="form-control h-50"
                          style={{ width: "70%" }}
                          id="name-edit-user"
                          value={customer2.fullname}
                          onChange={(e) => {
                            setsetCustomer2({
                              ...customer2,
                              ["fullname"]: e.target.value,
                            });
                          }}
                          name="fullname"
                        />
                      </div>
                      <div className="edit-user-item d-flex justify-content-between">
                        <label
                          className="title  mt-1"
                          style={{ width: "30%" }}
                          htmlFor="name-edit-user"
                        >
                          موبایل :
                        </label>
                        <div className="" style={{ width: "70%" }}>
                          <input
                            type="number"
                            style={{
                              textAlign: "right",
                              height: "39px",
                              marginTop: "10px",
                            }}
                            className={`form-control `}
                            id="name-edit-user"
                            value={customer2.mobile}
                            onChange={(e) => {
                              setsetCustomer2({
                                ...customer2,
                                ["mobile"]: e.target.value,
                              });
                            }}
                            name="mobile"
                          />
                          <div
                            class="text-danger"
                            style={{
                              display: `${invalid1 ? "block" : "none"}`,
                            }}
                          >
                            شماره موبایل نامعتبر است
                          </div>
                        </div>
                      </div>
                      <div className="edit-user-item d-flex justify-content-between">
                        <label
                          className="title  mt-1"
                          style={{ width: "30%" }}
                          htmlFor="name-edit-user"
                        >
                          تلفن :
                        </label>
                        <div className="" style={{ width: "70%" }}>
                          <input
                            type="number"
                            style={{
                              textAlign: "right",
                              height: "39px",
                              marginTop: "10px",
                            }}
                            className={`form-control  `}
                            id="name-edit-user"
                            value={customer2.tell}
                            onChange={(e) => {
                              setsetCustomer2({
                                ...customer2,
                                ["tell"]: e.target.value,
                              });
                            }}
                            name="tell"
                          />
                          <div
                            class="text-danger"
                            style={{
                              display: `${invalid2 ? "block" : "none"}`,
                            }}
                          >
                            شماره تلفن نامعتبر است
                          </div>
                        </div>
                      </div>
                      <div className="edit-user-item d-flex justify-content-between">
                        <label
                          className="title  mt-1"
                          style={{ width: "30%" }}
                          htmlFor="name-edit-user"
                        >
                          کد ملی :
                        </label>
                        <div className="" style={{ width: "70%" }}>
                          <input
                            type="number"
                            style={{
                              textAlign: "right",
                              height: "39px",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                            className={`form-control  `}
                            id="name-edit-user"
                            value={customer2.codemeli}
                            onChange={(e) => {
                              setsetCustomer2({
                                ...customer2,
                                ["codemeli"]: e.target.value,
                              });
                            }}
                            name="codemeli"
                          />
                          <div
                            class="text-danger"
                            style={{
                              display: `${invalid3 ? "block" : "none"}`,
                            }}
                          >
                            کد ملی نامعتبر است
                          </div>
                        </div>
                      </div>
                      <div className="edit-user-item d-flex justify-content-between">
                        <label
                          style={{ width: "30%" }}
                          className="title mt-1"
                          htmlFor="name-edit-user"
                        >
                          آدرس :
                        </label>

                        <textarea
                          type="number"
                          style={{
                            textAlign: "right",
                            height: "100px",
                            width: "70%",
                          }}
                          className="form-control"
                          id="name-edit-user"
                          value={customer2.address}
                          onChange={(e) => {
                            setsetCustomer2({
                              ...customer2,
                              ["address"]: e.target.value,
                            });
                          }}
                          name="address"
                        />
                      </div>
                      <div className="edit-user-item d-flex justify-content-between mt-3 me-2 pe-5">
                        <label
                          className="title mt-1"
                          htmlFor="name-edit-user"
                          style={{ width: "30%" }}
                        >
                          تاریخ تولد :
                        </label>
                        <DatePicker
                          id="birthdayts"
                          className="rmdp-prime w-100"
                          showOtherDays
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          name="birthdayts"
                          value={
                            (customer2.bdyear == 0 || customer2.bdyear == "") &&
                            (customer2.bdday == 0 || customer2.bdday == "") &&
                            (customer2.bdmonth == 0 || customer2.bdmonth == "")
                              ? ""
                              : `${customer2.bdyear}/${customer2.bdmonth}/${customer2.bdday}`
                          }
                          onChange={(dateObjects) =>
                            setsetCustomer2({
                              ...customer2,
                              ["bdday"]: dateObjects.day,
                              ["bdmonth"]: dateObjects.month,
                              ["bdyear"]: dateObjects.year,
                            })
                          }
                          style={{
                            backgroundColor: "white",
                            border: "1px solid #cbc7c7",
                            borderRadius: "4px",
                            height: " 60%",
                            width: "120%",
                          }}
                        />
                      </div>
                      <div className="edit-user-item d-flex flex-column mt-3">
                        <label className="title mt-1" htmlFor="name-edit-user">
                          نوع :
                          <small className="text-warning">
                            (ابتدا فروشگاه را انتخاب کرده و بعد نقش مورد نظر خود
                            را انتخاب کنید)
                          </small>{" "}
                        </label>
                        <div className="d-flex flex-column mt-1">
                          <div>
                            <label>فروشگاه ها</label>
                            {suppliers && (
                              <CreatableSelect
                                placeholder={"انتخاب فروشگاه"}
                                options={suppliers}
                                value={supplier}
                                className="w-100 text-dark user-label mt-2"
                                onChange={(e) => {
                                  let labelArray = [];
                                  labels.map((item) => {
                                    labelArray.push({
                                      value: item.value + "-" + e.value,
                                      label: item.label + "-" + e.label,
                                    });
                                  });
                                  labelArray.push(
                                    {
                                      value: "100-0",
                                      label: "مدیریت محصولات (سوپر ادمین)",
                                    },
                                    {
                                      value: "101-0",
                                      label: "(سوپر ادمین) مدیریت کاربران",
                                    },
                                    {
                                      value: "102-0",
                                      label: "مدیریت آپشن ها (سوپر ادمین)",
                                    },
                                    {
                                      value: "103-0",
                                      label: "مدیریت سفارشات (سوپر ادمین)",
                                    },
                                    {
                                      value: "104-0",
                                      label: "مدیریت فروشگاه (سوپر ادمین)",
                                    },
                                    { value: "300-0", label: "بازاریاب" }
                                  );
                                  setSmallLabels(labelArray);
                                  setSupplier(e);
                                }}
                              />
                            )}
                          </div>
                          <div className="mt-2">
                            <label>نقش ها</label>
                            {rolls && smallLabels != [] && (
                              <CreatableSelect
                                isMulti
                                placeholder={"انتخاب نقش"}
                                options={smallLabels}
                                value={rolls}
                                className="w-100 text-dark user-label mt-2"
                                onChange={(e) => {
                                  setRolls(e);
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  let mobileRegex = RegExp("^(\\+98|0)?9\\d{9}$");
                  let codemelliRegex = RegExp("^([0-9]){10}$");
                  let tellRegex = RegExp("^([0-9]){8}$");

                  let codmelliValidation =
                    codemelliRegex.test(customer2.codemeli) ||
                    customer2.codemeli == "";
                  let mobileValidation =
                    mobileRegex.test(customer2.mobile) ||
                    customer2.mobile == "";
                  let tellValidation =
                    tellRegex.test(customer2.tell) || customer2.tell == "";

                  if (
                    codmelliValidation &&
                    mobileValidation &&
                    tellValidation
                  ) {
                    document.querySelector("#close-edit-user").click();
                    console.log(rolls);
                    if (rolls.length > 0) {
                      rolls.map((item) => {
                        let dataArray = item.value.split("-");
                        if (
                          !allRolls.some(
                            (item2) =>
                              item2.value == dataArray[0] &&
                              item2.supplier_id == dataArray[1]
                          )
                        ) {
                          connection("api/Insert_UserRoll", {
                            supplier_id: dataArray[1],
                            uid: customers[index].users__id,
                            value: dataArray[0],
                          }).then((res) => {
                            if (!res.status) {
                              toast.error("لطفا دوباره امتحان کنید", {
                                position: "top-center",
                                autoClose: 2000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              });
                            }
                          });
                        }
                      });
                    }
                    if (allRolls.length > 0) {
                      allRolls.map((item) => {
                        if (
                          !rolls.some(
                            (item2) =>
                              item.value == item2.value.split("-")[0] &&
                              item.supplier_id == item2.value.split("-")[1]
                          )
                        ) {
                          connection("api/Delete_UserRoll", {
                            conditions: `supplier_id/=/${item.supplier_id}@@value/=/${item.value}@@uid/=/${customers[index].users__id}`,
                          }).then((res) => {
                            if (res.status == 0) {
                              toast.error("لطفا دوباره امتحان کنید", {
                                position: "top-center",
                                autoClose: 2000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              });
                            }
                          });
                        }
                      });
                    }
                    if (img != "") {
                      connection("api/upload_img", {
                        file: customer2.profile_pic_file_id,
                      }).then((res) => {
                        Update(false, status, customer2, res.result.id, index);
                      });
                    } else {
                      Update(false, status, customer2, "", index, rolls);
                    }
                  } else {
                    codmelliValidation ? setInvalid3(false) : setInvalid3(true);
                    mobileValidation ? setInvalid1(false) : setInvalid1(true);
                    tellValidation ? setInvalid2(false) : setInvalid2(true);
                  }
                }}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id={`editModal2`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کاربر
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data">
                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label htmlFor="address-edit-user" className="title w-25">
                      وضعیت{" "}
                    </label>
                    <div className="w-75">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label" htmlFor="inlineRadio1">
                          فعال
                        </label>
                        <input
                          class="form-check-input"
                          type="radio"
                          id="inlineRadio1"
                          checked={status2 == 1 ? true : false}
                          onClick={(e) => {
                            setStatus2(e.target.value == "on" ? 1 : 0);
                          }}
                          name="status"
                        />
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label" htmlFor="inlineRadio2">
                          غیر فعال
                        </label>
                        <input
                          class="form-check-input"
                          type="radio"
                          id="inlineRadio2"
                          checked={status2 == 0 ? true : false}
                          onClick={(e) => {
                            setStatus2(e.target.value == "on" ? 0 : 1);
                          }}
                          name="status"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Update(true, status2);
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id={`coinModal`}
        tabindex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                شارژ
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div>
                <label
                  htmlFor="coin"
                  className="title mx-3"
                  style={{ width: "fit-content" }}
                >
                  مقدار شارژ را وارد کنید :
                </label>
                <input
                  type="number"
                  style={{ width: "60%" }}
                  id="coin"
                  value={coin}
                  onChange={(e) => {
                    setCoin(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Coin(coin, customers[index].users__id);
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id={`coinModal2`}
        tabindex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                شارژ
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div>
                <label
                  htmlFor="coin"
                  className="title mx-3"
                  style={{ width: "fit-content" }}
                >
                  مقدار شارژ را وارد کنید :
                </label>
                <input
                  type="number"
                  style={{ width: "60%" }}
                  id="coin"
                  value={coin2}
                  onChange={(e) => {
                    setCoin2(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Coingroup(coin2);
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* {customers && <ReportModal index={customers[index]} />} */}
    </div>
  );
}

export default Modal;
